import { CookieStorageService } from '../services/storage/cookie-storage';
import { Storage } from '../services/storage/storage.interface';
import { EnumerableAbstract } from './enumerable.abstract';

class CaseEnum extends EnumerableAbstract {
    private storage: Storage;
    public listData = (): { [key: string]: any } => ({});
    constructor(storage: Storage) {
        super();
        this.storage = storage;
    }

    removeAll() {
        return Promise.resolve();
    }
    setEnum(obj: any) {
        Object.keys(obj).forEach((key: string) => {
            this.storage.setItem(`case_${key}`, JSON.stringify(obj[key]));
        });
    }
    getEnum(key: string) {
        const data = this.storage.getItem(`case_${key}`);

        return data && data !== 'undefined' ? JSON.parse(data) : [];
    }
}

const CaseEnumService = new CaseEnum(CookieStorageService);

export default CaseEnumService;
